export default {
  editingTitle: 'Editing QR Code menu for {{name}}',
  creatingTitle: 'Creating QR Code menu for {{name}}',
  creatingTitleAsset: 'Creating QR Code menu for asset',
  name: 'Name*',
  level: 'Level',
  assetTypes: 'Asset types*',
  assetPlaceLevel: 'Place associated with the asset',
  assetTypesRequired: 'You must select at least one asset type'
}
